import { render, staticRenderFns } from "./AggregatorUpdate.vue?vue&type=template&id=12fa1a9b&scoped=true"
import script from "./AggregatorUpdate.vue?vue&type=script&lang=js"
export * from "./AggregatorUpdate.vue?vue&type=script&lang=js"
import style0 from "./AggregatorUpdate.vue?vue&type=style&index=0&id=12fa1a9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fa1a9b",
  null
  
)

export default component.exports